import { sendExtractQuestionsEvent } from '../index';
import { EventAdapter } from './EventAdapter';

interface ExtractQuestionsEventAdapterParams {
  fileUploaded: boolean;
  fileUploadType: string | null;
  fileUploadSizeBytes: number | null;
  filesUploadedCount: number;
  includeExplanations: boolean;
  numQuestions?: number;
}

export class ExtractQuestionsEventAdapter extends EventAdapter {
  protected amplitudeEventFunction = sendExtractQuestionsEvent;
  protected intercomEventKey = 'extract_questions';

  constructor({
    fileUploaded,
    fileUploadType,
    fileUploadSizeBytes,
    filesUploadedCount,
    includeExplanations,
    numQuestions,
  }: ExtractQuestionsEventAdapterParams) {
    super();

    try {
      this.eventData = {
        file_uploaded: fileUploaded,
        file_upload_type: fileUploadType,
        file_upload_size_bytes: fileUploadSizeBytes,
        files_uploaded_count: filesUploadedCount,
        include_explanations: includeExplanations,
        ...(numQuestions !== undefined && { num_questions: numQuestions }),
      };
    } catch (err) {
      console.error('Error parsing analytics data', err);
    }
  }
}
